import { render } from "./calculator_ch.vue?vue&type=template&id=1b40962c"
import script from "./calculator_ch.vue?vue&type=script&lang=js"
export * from "./calculator_ch.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/project/wp-content/themes/resource-database/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__